import React from 'react';

import './Spinner.css';

import { cn } from '../../lib/css/className/className';
import { TestProps } from '../../internal/types/testTypes';
import { LoadingIndicatorProps } from '../../internal/types/loadingIndicatorTypes';
import { IconSize } from '../../icons';

const cls = cn('Spinner');

export type SpinnerColor = 'yellow' | 'black' | 'gray' | 'gray-2' | 'blue' | 'current';

export interface SpinnerProps extends TestProps, LoadingIndicatorProps {
    /**
     * Названия классов для элемента
     */
    className?: string;

    /**
     * Размер элемента.
     * Перечисленные размеры определены дизайн-системой.
     * @default 32
     */
    size?: IconSize;

    /**
     * Цвет спиннера
     * @default yellow
     */
    color?: SpinnerColor;
}

interface SpinnerOptions {
    /**
     * Offset по X и Y для viewbox.
     * По умолчанию 0.
     */
    viewBoxModifier: string | undefined;

    /**
     * Контур svg-элемента.
     */
    path: string;
}

const spinnerStyles = {
    '8': {
        viewBoxModifier: undefined,
        path: 'M4 1.5C2.61929 1.5 1.5 2.61929 1.5 4C1.5 5.38071 2.61929 6.5 4 6.5C4.41421 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 4.41421 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 4.41421 7.66421 4.75 7.25 4.75C6.83579 4.75 6.5 4.41421 6.5 4C6.5 2.61929 5.38071 1.5 4 1.5Z',
    },
    '12': {
        viewBoxModifier: undefined,
        path: 'M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C6.41421 10.5 6.75 10.8358 6.75 11.25C6.75 11.6642 6.41421 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 6.41421 11.6642 6.75 11.25 6.75C10.8358 6.75 10.5 6.41421 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5Z',
    },
    '16': {
        viewBoxModifier: undefined,
        path: 'M8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C8.48325 14.25 8.875 14.6418 8.875 15.125C8.875 15.6082 8.48325 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 8.48325 15.6082 8.875 15.125 8.875C14.6418 8.875 14.25 8.48325 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75Z',
    },
    '20': {
        viewBoxModifier: undefined,
        path: 'M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10C18 5.58172 14.4183 2 10 2Z',
    },
    '24': {
        viewBoxModifier: '-2',
        path: 'M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10C18 5.58172 14.4183 2 10 2Z',
    },
    '28': {
        viewBoxModifier: undefined,
        path: 'M11.2687 0.269012C13.9845 -0.271181 16.7994 0.00606596 19.3576 1.06569C21.9157 2.12532 24.1022 3.91973 25.6406 6.22202C27.1789 8.52431 28 11.2311 28 14C28 14.6904 27.4404 15.25 26.75 15.25C26.0597 15.25 25.5 14.6904 25.5 14C25.5 11.7255 24.8255 9.50211 23.5619 7.61095C22.2983 5.71978 20.5022 4.2458 18.4009 3.37539C16.2995 2.50498 13.9872 2.27725 11.7565 2.72098C9.52569 3.16471 7.47658 4.25997 5.86828 5.86828C4.25997 7.47658 3.16471 9.52569 2.72098 11.7565C2.27725 13.9872 2.50498 16.2995 3.37539 18.4009C4.2458 20.5022 5.71978 22.2983 7.61095 23.5619C9.50211 24.8255 11.7255 25.5 14 25.5C14.6904 25.5 15.25 26.0597 15.25 26.75C15.25 27.4404 14.6904 28 14 28C11.2311 28 8.52431 27.1789 6.22202 25.6406C3.91973 24.1022 2.12532 21.9157 1.06569 19.3576C0.00606596 16.7994 -0.271181 13.9845 0.269012 11.2687C0.809205 8.55301 2.14258 6.05845 4.10051 4.10051C6.05845 2.14258 8.55301 0.809205 11.2687 0.269012Z',
    },
    '32': {
        viewBoxModifier: undefined,
        path: 'M16 2.75C8.68223 2.75 2.75 8.68223 2.75 16C2.75 23.3178 8.68223 29.25 16 29.25C16.6904 29.25 17.25 29.8096 17.25 30.5C17.25 31.1904 16.6904 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16C0.25 7.30151 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30151 31.75 16C31.75 16.6904 31.1904 17.25 30.5 17.25C29.8096 17.25 29.25 16.6904 29.25 16C29.25 8.68223 23.3178 2.75 16 2.75Z',
    },
    '40': {
        viewBoxModifier: undefined,
        path: 'M16.0982 0.384303C19.9778 -0.387401 23.9992 0.0086658 27.6537 1.52242C31.3082 3.03617 34.4318 5.59962 36.6294 8.8886C38.827 12.1776 40 16.0444 40 20C40 20.8284 39.3284 21.5 38.5 21.5C37.6716 21.5 37 20.8284 37 20C37 16.6377 36.003 13.3509 34.135 10.5553C32.267 7.75968 29.612 5.58075 26.5056 4.29406C23.3993 3.00737 19.9811 2.67071 16.6835 3.32666C13.3858 3.98261 10.3567 5.6017 7.97919 7.97919C5.6017 10.3567 3.98261 13.3858 3.32666 16.6835C2.67071 19.9811 3.00737 23.3993 4.29406 26.5056C5.58075 29.612 7.75968 32.267 10.5553 34.135C13.351 36.003 16.6377 37 20 37C20.8284 37 21.5 37.6716 21.5 38.5C21.5 39.3284 20.8284 40 20 40C16.0444 40 12.1776 38.827 8.8886 36.6294C5.59962 34.4318 3.03617 31.3082 1.52242 27.6537C0.00866568 23.9992 -0.387401 19.9778 0.384303 16.0982C1.15601 12.2186 3.06082 8.65492 5.85787 5.85787C8.65492 3.06082 12.2186 1.15601 16.0982 0.384303Z',
    },
    '48': {
        viewBoxModifier: undefined,
        path: 'M19.3178 0.461164C23.9734 -0.464881 28.799 0.010399 33.1844 1.8269C37.5698 3.6434 41.3181 6.71954 43.9553 10.6663C46.5924 14.6131 48 19.2533 48 24C48 24.8284 47.3284 25.5 46.5 25.5C45.6716 25.5 45 24.8284 45 24C45 19.8466 43.7684 15.7865 41.4609 12.333C39.1534 8.8796 35.8736 6.18798 32.0364 4.59854C28.1991 3.0091 23.9767 2.59323 19.9031 3.40352C15.8295 4.21381 12.0877 6.21386 9.15077 9.15077C6.21386 12.0877 4.21381 15.8295 3.40352 19.9031C2.59323 23.9767 3.0091 28.1991 4.59854 32.0364C6.18798 35.8736 8.8796 39.1534 12.333 41.4609C15.7865 43.7684 19.8466 45 24 45C24.8284 45 25.5 45.6716 25.5 46.5C25.5 47.3284 24.8284 48 24 48C19.2533 48 14.6131 46.5924 10.6663 43.9553C6.71954 41.3181 3.6434 37.5698 1.8269 33.1844C0.0103986 28.799 -0.464881 23.9734 0.461164 19.3178C1.38721 14.6623 3.67299 10.3859 7.02945 7.02945C10.3859 3.67299 14.6623 1.38721 19.3178 0.461164Z',
    },
    '64': {
        viewBoxModifier: undefined,
        path: 'M32 3C15.9837 3 3 15.9837 3 32C3 48.0163 15.9837 61 32 61C32.8284 61 33.5 61.6716 33.5 62.5C33.5 63.3284 32.8284 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 32.8284 63.3284 33.5 62.5 33.5C61.6716 33.5 61 32.8284 61 32C61 15.9837 48.0163 3 32 3Z',
    },
    '120': {
        viewBoxModifier: undefined,
        path: 'M60 3C28.5198 3 3 28.5198 3 60C3 91.4802 28.5198 117 60 117C60.8284 117 61.5 117.672 61.5 118.5C61.5 119.328 60.8284 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60C120 60.8284 119.328 61.5 118.5 61.5C117.672 61.5 117 60.8284 117 60C117 28.5198 91.4802 3 60 3Z',
    },
} satisfies Partial<Record<IconSize, SpinnerOptions>>;

const isSpinnerSize = (size: IconSize): size is keyof typeof spinnerStyles => {
    return size in spinnerStyles;
};

/**
 * Компонент для отображения компонента-заглушки во время загрузки
 */
export const Spinner: React.FC<SpinnerProps> = React.memo(function Spinner(props) {
    const { className, size = '32', color = 'yellow', isLoadingIndicator = true } = props;
    // Берем если переданного size нет в spinnerStyles, то фоллбэчимся в 120 и скейлим до нужного
    const { path, viewBoxModifier = '0' } = isSpinnerSize(size) ? spinnerStyles[size] : spinnerStyles['120'];
    const viewBox = `${viewBoxModifier} ${viewBoxModifier} ${size} ${size}`;

    // реализовано через path, т.к. circle не отображается в некоторых браузерах
    return (
        <svg
            data-testid={props['data-testid']}
            data-loading-indicator={isLoadingIndicator || undefined}
            className={cls({ color }, [className])}
            viewBox={viewBox}
            width={size}
            height={size}
            fill="none"
        >
            <path d={path} />
        </svg>
    );
});
